import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";

interface FormButtonsProps {
  isEditMode: boolean;
  isFormValid: boolean;
  isSubmitting: boolean;
  isUploadingLogo: boolean;
  isSendingInvitation: boolean;
  formInitialized: boolean;
  hasChanges: boolean;
  goBack: () => void;
}

export const FormButtons = ({
  isEditMode,
  isFormValid,
  isSubmitting,
  isUploadingLogo,
  isSendingInvitation,
  formInitialized,
  hasChanges,
  goBack,
}: FormButtonsProps) => {
  const { t } = useLanguage();

  const isButtonDisabled = !formInitialized || !isFormValid || isSubmitting || isUploadingLogo || (isEditMode && !hasChanges);
  const showNoChangesMessage = isEditMode && !hasChanges && formInitialized && isFormValid;

  return (
    <div className="flex flex-col items-end gap-2">
      <div className="flex justify-end gap-4">
      <Button type="button" variant="outline" onClick={goBack} className="px-8 py-2.5 text-base">
        {t("companyForm.buttons.cancel")}
      </Button>
      <Button
        type="submit"
        disabled={isButtonDisabled}
        className={`px-8 py-2.5 text-base text-white ${
          formInitialized && isFormValid && !isSubmitting && !isUploadingLogo && (!isEditMode || hasChanges)
            ? "bg-teal-600 hover:bg-teal-700"
            : "bg-teal-600/50 cursor-not-allowed"
        }`}
      >
        {isSubmitting ? (
          <div className="flex items-center gap-2">
            <div className="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
            {isEditMode
              ? t("companyForm.buttons.updating")
              : isSendingInvitation
              ? t("companyForm.invitation.addingAndInviting")
              : t("companyForm.buttons.adding")}
          </div>
        ) : isUploadingLogo ? (
          <div className="flex items-center gap-2">
            <div className="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
            {t("companyForm.buttons.uploadingLogo")}
          </div>
        ) : isEditMode ? (
          t("companyForm.buttons.update")
        ) : (
          t("companyForm.buttons.add")
        )}
      </Button>
      </div>
      {showNoChangesMessage && (
        <p className="text-sm text-gray-500 italic">
          {t("companyForm.noChanges")}
        </p>
      )}
    </div>
  );
};
